module.exports = __webpack_public_path__ + "static/img/3.d9820e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/3.jpg
// module id = UGdO
// module chunks = 0